<input
    #inputElement
    type="text"
    inputmode="numeric"
    [attr.formControlName]="formControlName()"
    [required]="required()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [maxLength]="maxLength()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    class="w-full input"
    [ngClass]="readonly() || disabled() ? 'bg-gray-100' : ''"
/>
